import {
  GET_DASH_ANALYTICS,
  GET_ADMIN_PROPERTIES,
  GET_ANALYTICS_DATA,
  GET_ANALYTICS_CARD_DATA,
  GET_UNVERIFIED_TENANT,
  GET_UNVERIFIED_OWNER,
  GET_UNVERIFIED_PROPERTIES,
  GET_ALL_ADVERTISED_PROPERTIES,
  GET_TODO_LIST,GET_TOTAL_INCOME
} from "./actions";

const initialState = {
  dashboard: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  unverifiedTenants:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  unverifiedOwner:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  unverifiedProperties:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  advertisedProperties:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  todoList:[],
 
  dashboardData: {},
  incomeData:{},
  loading: true,
  analyticsData: [],
  analyticsCardData: {},
};

const dashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASH_ANALYTICS:
      return {
        ...state,
        loading: false,
        dashboardData: payload,
      };
    case GET_TOTAL_INCOME:
      return {
        ...state,
        incomeData:payload
      }
    case GET_UNVERIFIED_TENANT:
      return{
        ...state,
        unverifiedTenants:payload 
      }
    case GET_UNVERIFIED_OWNER:
      return {
        ...state,
        unverifiedOwner:payload 
      }
    case GET_UNVERIFIED_PROPERTIES:
      return {
        ...state,
        unverifiedProperties:payload 
      }
    case GET_ALL_ADVERTISED_PROPERTIES:
      return{
        ...state,
        advertisedProperties:payload 
      }
    case GET_TODO_LIST:
      return {
        ...state,
        todoList:payload
      }
    case GET_ADMIN_PROPERTIES:
      return {
        ...state,
        loading: false,
        dashboard: payload,
      };
    case GET_ANALYTICS_DATA:
      return {
        ...state,
        loading: false,
        analyticsData: payload,
      };
    case GET_ANALYTICS_CARD_DATA:
      return {
        ...state,
        loading: false,
        analyticsCardData: payload,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
